import { Highlight } from '@/models/Highlight';
import { action } from 'typesafe-actions';
import { HighlightDataResponse, HighlightsRequest, HighlightTypes } from './types';

export const sendHighlightRequest = (highlight: Highlight) => action(HighlightTypes.SEND_HIGHLIGHT_REQUEST, highlight);
export const sendHighlightSuccess = (highlight: Highlight) => action(HighlightTypes.SEND_HIGHLIGHT_SUCCESS, highlight);
export const sendHighlightFailure = () => action(HighlightTypes.SEND_HIGHLIGHT_FAILURE);
export const highlightsRequest = (data: HighlightsRequest) => action(HighlightTypes.HIGHLIGHTS_REQUEST, data);
export const highlightsFailure = () => action(HighlightTypes.HIGHLIGHTS_FAILURE);
export const highlightsSuccess = (data: HighlightDataResponse) => action(HighlightTypes.HIGHLIGHTS_SUCCESS, data);
export const highlightsClear = () => action(HighlightTypes.HIGHLIGHTS_CLEAR);
